// extracted by mini-css-extract-plugin
export default {"validatePanel":"validatePanel-OkdhH","body":"body-vzmxT","form":"form-koVll","rightPane":"rightPane-oRfnT","inlineDialog":"inlineDialog-Wre_B"};